import { ApiBaseWithStandardErrorHandling } from "../../../components-shared/api/base/api-base-with-standard-error-handling.js";
import { IStandardApiError } from "../../../components-shared/api/base/i-standard-api-error.js";
import { logStandardApiError } from "../../../components-shared/utils/notify-error-reporter.js";
import { IFreeShippingInfoContract } from "./interfaces/free-shipping-info-contract.js";

export class FreeShippingApi extends ApiBaseWithStandardErrorHandling {
    constructor() {
        super("/handlers/public");
    }

    protected reportError(error: IStandardApiError): void {
        logStandardApiError(error);
    }

    public async getFreeShippingData(orderSumAmount: number = 0) : Promise<IFreeShippingInfoContract> {
        return await this.get(`/estoredata.ashx?action=GetFreeShippingStatus&amount=${orderSumAmount}`);
    }
}